import '../styles/crew.scss';

type CrewListStepProps = {
  number: number;
  title: string;
  subtitle: string;
  isStepRequired?: boolean;
  isStepDisabled?: boolean;
  actionComponent?: React.ReactElement;
  handleDownloadDocumentPreview?: () => void;
};

const CrewListStep = ({
  number,
  title,
  subtitle,
  isStepRequired = false,
  isStepDisabled = false,
  actionComponent,
}: CrewListStepProps) => {
  return (
    <>
      <div
        className={`crew-steps__step ${isStepDisabled ? 'crew-steps__step_disabled' : ''}`}>
        <div
          className={`crew-steps__number ${isStepDisabled ? 'crew-steps__number_disabled' : ''}`}>
          {number}
        </div>
        <div className="crew-steps__content">
          <h3
            className={`crew-steps__title ${isStepDisabled ? 'crew-steps__title_disabled' : ''}`}>
            {title}
            {isStepRequired ? (
              <span className="crew-steps__required"> *</span>
            ) : null}
          </h3>
          <p
            className={`crew-steps__description ${isStepDisabled ? 'crew-steps__description_disabled' : ''}`}>
            {subtitle}
          </p>
          {actionComponent}
        </div>
      </div>
    </>
  );
};

export default CrewListStep;
